import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import Icon from "./Icon";
import { useAuthContext, useDCContext } from "../../context";
import MessageBanner from "./MessageBanner";

/** MessageBanner populated by Dynamic Content "global_messages__*" */
export const GlobalMessageBanner = () => {
  const { getDynamicReplacement, existsDynamicReplacements } = useDCContext();
  const auth = useAuthContext();
  const customerCode = auth?.user?.customerCode?.toLowerCase();

  const keyTitle = `global_messages__${customerCode}__title`,
    keyMessage = `global_messages__${customerCode}__message`,
    keyColour = `global_messages__${customerCode}__colour_hex`,
    keyIcon = `global_messages__${customerCode}__icon`;

  const hasGlobalMessage =
    existsDynamicReplacements(keyTitle) &&
    existsDynamicReplacements(keyMessage);
  if (!hasGlobalMessage) {
    return null;
  }

  const title = getDynamicReplacement(keyTitle, {}, "", true);
  const message = getDynamicReplacement(keyMessage, {}, "", true);
  const colour = existsDynamicReplacements(keyColour)
    ? getDynamicReplacement(keyColour, {}, "#000000", true)
    : undefined;
  const icon = existsDynamicReplacements(keyIcon)
    ? getDynamicReplacement(keyIcon, {}, "timer", true)
    : undefined;

  return (
    <MessageBanner title={title} message={message} color={colour} icon={icon} />
  );
};

export default GlobalMessageBanner;
